<template>
  <div class="parts-icon">
    <picture v-if="usePicture">
      <source type="image/webp" :srcset="getTileSet('webp')" />
      <img
        :src="getTileSet('png')"
        :alt="'icon ' + partsId"
        :style="getTilePosition(partsId, 'img')"
      />
    </picture>
    <span
      v-else
      :style="
        'background-image: url(' +
        getTileSet('webp') +
        '); ' +
        'background-position: ' +
        getTilePosition(partsId, 'bg') +
        '; '
      "
    ></span>
  </div>
</template>

<script>
export default {
  name: "IconBtoParts",

  props: {
    partsId: {
      type: String,
    },
    usePicture: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      assetsRoute: process.env.VUE_APP_LIT_ASSET_ROUTE,
    };
  },

  mounted() {
    //this.assetsRoute = process.env.VUE_APP_LIT_ASSET_ROUTE;
  },

  methods: {
    /**
     * パーツIDを受け取って、画像オフセット位置を返す
     *
     * @deprecated
     */
    idToPartsOffset(id) {
      let ret = Number(id) * 24 - 24;
      return "-" + ret + "px";
    },
    /**
     * パーツIDを受け取ってタイルセットのオフセット位置を返す
     * @param  String id パーツID
     * @return String    オフセット位置
     */
    getTilePosition(id, cssType) {
      let top = 0;
      let left = 0;
      top = Number(Math.floor(Number(id) / 16));
      left = Number(Number(id) - top * 16);

      if ("img" === cssType) {
        return (
          "transform: translate(-" + left * 24 + "px, -" + top * 24 + "px);"
        );
      } else {
        return "top -" + top * 24 + "px left -" + left * 24 + "px";
      }
    },
    /**
     * タイルセットのURLを返す
     *
     * @return String
     */
    getTileSet(imageType) {
      if ("webp" === imageType) {
        return this.assetsRoute + "lit_item_cache/partsset.webp";
      } else {
        return this.assetsRoute + "lit_item_cache/partsset.png";
      }
    },
  },
};
</script>

<style scoped lang="stylus">

@css {
  .parts-icon {
    width: 24px;
    height: 24px;
    filter: drop-shadow(1px 3px 2px rgba(0, 0, 0, 0.25));
    @apply inline-block overflow-hidden align-middle
  }
  .parts-icon img {
    @apply max-w-none pointer-events-none;
  }
  .parts-icon span {
    max-width: none;
    height: 24px;
    @apply block transform shadow bg-no-repeat
  }
}
</style>
